import { React, useState, useEffect } from 'react';
import {
    Box,
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    Alert,
} from '@mui/material';
import { AdminAdsense as AdminAdsenseApi } from '../../../api/admin-cf-usage';

const METRIC_LABELS = {
    ESTIMATED_EARNINGS: 'Estimated Earnings',
    PAGE_VIEWS: 'Page Views',
    CLICKS: 'Clicks',
    PAGE_VIEWS_RPM: 'Page RPM',
    IMPRESSIONS_RPM: 'Impressions RPM',
};

const CELL = { whiteSpace: 'nowrap', py: 1.25, px: 4 };

function formatValue(name, value) {
    if (name === 'ESTIMATED_EARNINGS') return `$${parseFloat(value).toFixed(2)}`;
    if (name.endsWith('RPM')) return `$${parseFloat(value).toFixed(2)}`;
    return Number(value).toLocaleString();
}

function GoogleAdsense() {
    const [adsense, setAdsense] = useState({ loading: false, data: null, error: null });

    useEffect(() => {
        AdminAdsenseApi(setAdsense);
    }, []);

    const { loading, data, error } = adsense;

    return (
        <Box sx={{ m: 2 }}>
            {loading && <CircularProgress size={16} sx={{ mb: 2 }} />}
            {error && (
                <Alert severity='error' sx={{ mb: 2 }}>
                    {error}
                </Alert>
            )}
            {data && (
                <>
                    <Typography variant='body2' color='text.secondary' sx={{ mb: 1.5 }}>
                        Month-to-date · {data.start_date} – {data.end_date}
                    </Typography>
                    <Table size='small' sx={{ minWidth: 400, mb: 3 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={CELL}>Metric</TableCell>
                                <TableCell sx={{ ...CELL, textAlign: 'right' }}>Value</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.metrics.map((m) => (
                                <TableRow key={m.name} hover>
                                    <TableCell sx={CELL}>{METRIC_LABELS[m.name] ?? m.name}</TableCell>
                                    <TableCell sx={{ ...CELL, textAlign: 'right' }}>
                                        {formatValue(m.name, m.value)}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    {data.alerts.length > 0 && (
                        <Box>
                            {data.alerts.map((a, i) => (
                                <Alert key={i} severity='warning' sx={{ mb: 1 }}>
                                    {a.message}
                                </Alert>
                            ))}
                        </Box>
                    )}
                </>
            )}
        </Box>
    );
}

export { GoogleAdsense };
